import { FC, SVGProps } from "react";

type LineIconProps = SVGProps<SVGSVGElement> & {
  direction?: "horizontal" | "vertical";
};

export const LineIcon: FC<LineIconProps> = ({
  fill = "white",
  className,
  width = 16,
  height = 16,
  direction = "horizontal",
  style,
  ...props
}) => {
  const getRotation = () => {
    switch (direction) {
      case "horizontal":
        return "0deg";
      case "vertical":
        return "90deg";
      default:
        return "0deg";
    }
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 225 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
        transform: `rotate(${getRotation()})`,
      }}
      {...props}
    >
      <path
        d="M58.2 30.7V15.3h108.4v15.4H58.2zM0 22.6C0 10.1 10.1 0 22.5 0 35 0 45.1 10.2 45 22.7 44.9 34.9 35 44.9 22.7 45 10.2 45.1 0 35 0 22.6zm225-.3c.1 12.5-10 22.6-22.5 22.6-12.4.1-22.5-10.1-22.5-22.5C180 10.2 190 .1 202.2 0c12.5-.1 22.7 9.9 22.8 22.3z"
        fill={fill}
      />
    </svg>
  );
};
